import { mergeStyleSets } from "@fluentui/react";

export const chatboxStyles = mergeStyleSets({
  wrapper: {
    position: 'relative',
    maxWidth: '100%',
    margin: '0 auto',
  },

  disclaimerWrapper: {
    maxWidth: '100%',
    display: "flex",
    alignItems: "center"
  },

  textField: {
    selectors: {
      '.ms-TextField-fieldGroup': {
        borderRadius: 10,
        paddingRight: 56,
        paddingTop: 10,
        border: '1px solid #ccc',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        minHeight: 96,
        transition: 'border 0.2s ease, box-shadow 0.2s ease'
      },
      '.ms-TextField-fieldGroup::after': {
        borderRadius: 10,
      },
      '.ms-TextField-field': {
        padding: '12px 16px',
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
    },
  },

  disclaimer: {
    marginTop: 4,
    marginBottom: 4,
    fontSize: '0.85rem',
    color: '#666',
    textAlign: 'center',
    flex: 1,
  },

  sendButton: {
    position: 'absolute',
    bottom: "45%",
    right: 12,
    borderRadius: '50%',
    // backgroundColor: '#0078d4',
    color: 'white',
    width: 40,
    height: 40,
    minWidth: 40,
    minHeight: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    zIndex: 10,
    selectors: {
      ':hover:not(:disabled)': {
        backgroundColor: '#005a9e',
      },
      ':disabled': {
        pointerEvents: 'none',
      },
    },
  },
});
